const API_URL = "https://apibasegateway.shabinja.com/api/v1"; //  ادرس سرور api  ها

export default API_URL;
